import CallForAppointmentOrConfirmIPR from 'components/Profile/PracticeGuidelines/Actions/CallForAppointmentOrConfirmIPR'
import Frequency from 'components/Profile/PracticeGuidelines/Actions/Frequency'
import InstructForChewies from 'components/Profile/PracticeGuidelines/Actions/InstructForChewies'
import KeepAlignersOrGoBack from 'components/Profile/PracticeGuidelines/Actions/KeepAlignersOrGoBack'
import LimitSetForXDays from 'components/Profile/PracticeGuidelines/Actions/LimitSetForXDays'
import MessagePatient from 'components/Profile/PracticeGuidelines/Actions/MessagePatient'
import NotifyPractice from 'components/Profile/PracticeGuidelines/Actions/NotifyPractice'
import PauseScans from 'components/Profile/PracticeGuidelines/Actions/PauseScans'
import SendBrushingInstructions from 'components/Profile/PracticeGuidelines/Actions/SendBrushingInstructions'
import StayInAlignerUntilReplacedOrAdvance from 'components/Profile/PracticeGuidelines/Actions/StayInAlignerUntilReplacedOrAdvance'
import TypicalWireSequence from 'components/Profile/PracticeGuidelines/Actions/TypicalWireSequence'

export const GuidelineCategories = {
  AlignersTxTracking: 'alignersTxTracking',
  BracesTxTracking: 'bracesTxTracking',
  OralHygiene: 'oralHygiene',
  TxGoals: 'txGoals',
  RetentionTracking: 'retentionTracking',
  ObservationTracking: 'observationTracking',
  Elastics: 'elastics',
  IPR: 'IPR',
  RPE: 'RPE',
  OtherAppliancesAndGuidelines: 'otherAppliancesAndGuidelines'
}

export const TIERED_HI_PLAN_GROUPS = [
  'grin-all-inclusive',
  'grin-subscription',
  'grin-subscription-v2',
  'grin-enterprise'
]

export const AdministrativeInfoId = 'administrativeInfo'

export const GuidelineItems = {
  TypicalAdvanceFrequency: 'typicalAdvanceFrequency',
  AlignerFit: 'alignerFit',
  AlignerSlightlyUnseating: 'alignerSlightlyUnseating',
  AlignerSignificantlyUnseating: 'alignerSignificantlyUnseating',
  MissingAttaching: 'missingAttaching',
  ScanFrequency: 'scanFrequency',
  NoChange: 'noChange',
  MinorChange: 'minorChange',
  SignificantChange: 'significantChange',
  NotifyWhenGoalIsReached: 'notifyWhenGoalIsReached',
  LastAligner: 'lastAligner',
  BrokenWireWireOutOfBracketBrokenChainMissingOTie: 'brokenWireWireOutOfBracketBrokenChainMissingOTie',
  ReadinessForWireChange: 'readinessForWireChange',
  PlaqueInflamationDetected: 'plaqueInflamationDetected',
  CriticalBadOralHygiene: 'criticalBadOralHygiene',
  WhenATxGoalIsReached: 'whenATxGoalIsReached',
  ValidatePatientCompliance: 'validatePatientCompliance',
  LowPatientCompliance: 'lowPatientCompliance',
  WhenReachingAlignerNumber: 'whenReachingAlignerNumber'
}

export const ActionTypes = {
  MessagePatient: 'messagePatient',
  NotifyPractice: 'notifyPractice',
  KeepAlignersOrGoBack: 'keepAlignersOrGoBack',
  InstructForChewies: 'instructForChewies',
  Frequency: 'frequency',
  TypicalWireSequence: 'typicalWireSequence',
  SendBrushingInstructionsToThePatient: 'sendBrushingInstructionsToThePatient',
  LimitSetForXDays: 'limitSetForXDays',
  StayInAlignerUntilReplacedOrAdvance: 'stayInAlignerUntilReplacedOrAdvance',
  PauseScans: 'pauseScans',
  TypicalAdvanceFrequency: 'typicalAdvanceFrequency',
  CallForAppointmentOrConfirmIPR: 'callForAppointmentOrConfirmIPR'
}

export const ActionTypeComponents = {
  [ActionTypes.MessagePatient]: MessagePatient,
  [ActionTypes.NotifyPractice]: NotifyPractice,
  [ActionTypes.KeepAlignersOrGoBack]: KeepAlignersOrGoBack,
  [ActionTypes.InstructForChewies]: InstructForChewies,
  [ActionTypes.Frequency]: Frequency,
  [ActionTypes.TypicalWireSequence]: TypicalWireSequence,
  [ActionTypes.SendBrushingInstructionsToThePatient]: SendBrushingInstructions,
  [ActionTypes.LimitSetForXDays]: LimitSetForXDays,
  [ActionTypes.StayInAlignerUntilReplacedOrAdvance]: StayInAlignerUntilReplacedOrAdvance,
  [ActionTypes.CallForAppointmentOrConfirmIPR]: CallForAppointmentOrConfirmIPR,
  [ActionTypes.PauseScans]: PauseScans
}

export const PracticeGuidelinesConfig = {
  [GuidelineCategories.AlignersTxTracking]: {
    [GuidelineItems.TypicalAdvanceFrequency]: [ActionTypes.Frequency],
    [GuidelineItems.AlignerFit]: [ActionTypes.MessagePatient, ActionTypes.NotifyPractice],
    [GuidelineItems.AlignerSlightlyUnseating]: [
      ActionTypes.MessagePatient,
      ActionTypes.KeepAlignersOrGoBack,
      ActionTypes.InstructForChewies,
      ActionTypes.NotifyPractice,
      ActionTypes.LimitSetForXDays
    ],
    [GuidelineItems.AlignerSignificantlyUnseating]: [
      ActionTypes.MessagePatient,
      ActionTypes.KeepAlignersOrGoBack,
      ActionTypes.InstructForChewies,
      ActionTypes.NotifyPractice,
      ActionTypes.LimitSetForXDays
    ],
    [GuidelineItems.MissingAttaching]: [
      ActionTypes.MessagePatient,
      ActionTypes.StayInAlignerUntilReplacedOrAdvance,
      ActionTypes.NotifyPractice
    ],
    [GuidelineItems.LastAligner]: [ActionTypes.MessagePatient, ActionTypes.NotifyPractice, ActionTypes.PauseScans],
    [GuidelineItems.ScanFrequency]: [ActionTypes.Frequency]
  },
  [GuidelineCategories.BracesTxTracking]: {
    [GuidelineItems.BrokenWireWireOutOfBracketBrokenChainMissingOTie]: [
      ActionTypes.MessagePatient,
      ActionTypes.NotifyPractice
    ],
    [GuidelineItems.ReadinessForWireChange]: [ActionTypes.NotifyPractice, ActionTypes.TypicalWireSequence],
    [GuidelineItems.ScanFrequency]: [ActionTypes.Frequency]
  },
  [GuidelineCategories.OralHygiene]: {
    [GuidelineItems.PlaqueInflamationDetected]: [
      ActionTypes.MessagePatient,
      ActionTypes.NotifyPractice,
      ActionTypes.SendBrushingInstructionsToThePatient
    ],
    [GuidelineItems.CriticalBadOralHygiene]: [ActionTypes.MessagePatient, ActionTypes.NotifyPractice]
  },
  [GuidelineCategories.TxGoals]: {
    [GuidelineItems.WhenATxGoalIsReached]: [ActionTypes.NotifyPractice]
  },
  [GuidelineCategories.RetentionTracking]: {
    [GuidelineItems.ScanFrequency]: [ActionTypes.Frequency],
    [GuidelineItems.NoChange]: [ActionTypes.MessagePatient, ActionTypes.NotifyPractice],
    [GuidelineItems.MinorChange]: [ActionTypes.MessagePatient, ActionTypes.NotifyPractice],
    [GuidelineItems.SignificantChange]: [ActionTypes.MessagePatient, ActionTypes.NotifyPractice]
  },
  [GuidelineCategories.ObservationTracking]: {
    [GuidelineItems.ScanFrequency]: [ActionTypes.Frequency],
    [GuidelineItems.NotifyWhenGoalIsReached]: [ActionTypes.NotifyPractice]
  },
  [GuidelineCategories.Elastics]: {
    [GuidelineItems.ValidatePatientCompliance]: [ActionTypes.MessagePatient],
    [GuidelineItems.LowPatientCompliance]: [ActionTypes.MessagePatient, ActionTypes.NotifyPractice]
  },
  [GuidelineCategories.IPR]: {
    [GuidelineItems.WhenReachingAlignerNumber]: [
      ActionTypes.MessagePatient,
      ActionTypes.CallForAppointmentOrConfirmIPR,
      ActionTypes.NotifyPractice
    ]
  },
  [GuidelineCategories.RPE]: {
    [GuidelineItems.ValidatePatientCompliance]: [ActionTypes.MessagePatient],
    [GuidelineItems.LowPatientCompliance]: [ActionTypes.MessagePatient, ActionTypes.NotifyPractice]
  },
  [GuidelineCategories.OtherAppliancesAndGuidelines]: {}
}

export const PatientBriefCategoryOrder = {
  [GuidelineCategories.AlignersTxTracking]: 1,
  [GuidelineCategories.BracesTxTracking]: 2,
  [GuidelineCategories.OralHygiene]: 3,
  [GuidelineCategories.Elastics]: 4,
  [GuidelineCategories.TxGoals]: 5,
  [GuidelineCategories.RetentionTracking]: 6,
  [GuidelineCategories.ObservationTracking]: 7,
  [GuidelineCategories.IPR]: 8,
  [GuidelineCategories.RPE]: 9,
  [GuidelineCategories.OtherAppliancesAndGuidelines]: 10
}

export const DEFAULT_RETENTION_TRACKING_PRACTICE_GUIDELINES = {
  isEnabled: false,
  items: {
    [GuidelineItems.ScanFrequency]: {
      [ActionTypes.Frequency]: {
        frequency: 90,
        isCustom: false
      }
    },
    [GuidelineItems.NoChange]: {
      [ActionTypes.MessagePatient]: { isChecked: true },
      [ActionTypes.NotifyPractice]: { isChecked: false }
    },
    [GuidelineItems.MinorChange]: {
      [ActionTypes.MessagePatient]: { isChecked: true },
      [ActionTypes.NotifyPractice]: { isChecked: false }
    },
    [GuidelineItems.SignificantChange]: {
      [ActionTypes.MessagePatient]: { isChecked: false },
      [ActionTypes.NotifyPractice]: { isChecked: true }
    }
  },
  note: ''
}

export const DEFAULT_OBSERVATION_TRACKING_PRACTICE_GUIDELINES = {
  isEnabled: false,
  items: {
    [GuidelineItems.ScanFrequency]: {
      [ActionTypes.Frequency]: {
        frequency: 90,
        isCustom: false
      }
    },
    [GuidelineItems.NotifyWhenGoalIsReached]: {
      [ActionTypes.NotifyPractice]: { isChecked: true }
    }
  },
  note: ''
}

export const PatientBriefModalMode = {
  NewPatient: 'new-patient',
  Update: 'update',
  View: 'view'
}

export const PatientBriefActions = {
  UntrackedTeeth: 'untrackedTeeth',
  Attachments: 'attachments',
  Class1Achieved: 'class1Achieved',
  CrossbiteCorrected: 'crossbiteCorrected',
  OverbiteCorrected: 'overbiteCorrected',
  MidlineCorrected: 'midlineCorrected',
  WireSequence: 'wireSequence',
  AlignerNumberReached: 'alignerNumberReached',
  NumberOfTurns: 'numberOfTurns',
  Elastics: 'elastics',
  NightTimeOnly: 'nightTimeOnly',
  TypicalAdvanceFrequency: 'typicalAdvanceFrequency'
}

export const ElasticColors = [
  '#FF7A00',
  '#00D1FF',
  '#FF007A',
  '#BF56FF',
  '#43D48E',
  '#9F6E34',
  '#3A7FD0',
  '#FF1F1F',
  '#636989'
]
